import { DECK_STORAGE_COOKIE } from '../constants';

export function checkGetParamsForDeckId(): string | null {
  const urlParams = new URLSearchParams(window.location.search);
  const deckId = urlParams.get('d');

  if (deckId) {
    console.debug(`Deck ID found in URL parameters: ${deckId}`);
    setDeckId(deckId);
    return deckId;
  }

  return null;
}

export function setDeckId(deckId: string): void {
  localStorage.setItem(DECK_STORAGE_COOKIE.DECK_STORAGE_NAME, deckId);
  console.debug(`Deck ID set: ${deckId}`);
}

export function getDeckId(): string | null {
  const deckId = localStorage.getItem(DECK_STORAGE_COOKIE.DECK_STORAGE_NAME);

  if (deckId) {
    console.debug(`Deck ID retrieved from local storage: ${deckId}`);
    localStorage.removeItem(DECK_STORAGE_COOKIE.DECK_STORAGE_NAME);
    return deckId;
  }

  return null;
}
